import {
  FETCH_INVOICES_SUCCESS,
  FETCHING_INVOICES,
  FETCHING_INVOICES_LINES,
  FETCHING_INVOICES_LINES_SUCCESS, RESET_INVOICES, RESET_INVOICES_LINES,
  DELETE_INVOICES_SUCCESS, DELETE_INVOICES_LINES_SUCCESS, FETCHING_INVOICES_LINES_UNFILTERED,
  FETCH_INVOICE_SUCCESS, FETCHING_INVOICE
} from './InvoicesConstants';
import axios from 'axios';
import { exportFile } from 'redux/files/FilesActions';
import { STRING, NUMBER, DATE } from 'shared/constants/InvoiceFiltersTypes';

const getUrlFilterParams = filtersState => {
  let urlFilterParams = ``;
  filtersState.map(invFilter => {
    if ((invFilter.data.type === STRING || invFilter.data.type === DATE) && invFilter.data.value) {
      urlFilterParams += `&${invFilter.data.key}=${invFilter.data.value}`;
    }
    if (invFilter.data.type === NUMBER) {
      if (invFilter.data.min.value) {
        urlFilterParams += `&${invFilter.data.min.key}=${invFilter.data.min.value}`;
      }
      if (invFilter.data.max.value) {
        urlFilterParams += `&${invFilter.data.max.key}=${invFilter.data.max.value}`;
      }
    }
  });
  return urlFilterParams;
};

const fetchingInvoices = () => ({ type: FETCHING_INVOICES });
const fetchInvoicesSuccess = (invoices, pageState) => ({ type: FETCH_INVOICES_SUCCESS, invoices, pageState });
const fetchingInvoicesLinesSuccess = (invoicesLines, pageState) => ({ type: FETCHING_INVOICES_LINES_SUCCESS, invoicesLines, pageState });
const fetchingInvoicesLines = () => ({ type: FETCHING_INVOICES_LINES });
const resetInvoices = () => ({ type: RESET_INVOICES });
const resetInvoicesLines = () => ({ type: RESET_INVOICES_LINES });
const deleteInvoicesSuccess = () => ({ type: DELETE_INVOICES_SUCCESS });
const deleteInvoiceLinesSuccess = () => ({ type: DELETE_INVOICES_LINES_SUCCESS });
const fetchInvoiceLinesUnfilteredSuccess = invoicesLines => ({ type: FETCHING_INVOICES_LINES_UNFILTERED, invoicesLines });
const fetchingInvoice = () => ({type: FETCHING_INVOICE });
const fetchInvoiceSuccess = invoice => ({type: FETCH_INVOICE_SUCCESS, invoice });

const url = 'utm/v1/transactions';
const linesUrl = 'utm/v1/invoice-lines';
const exportUrl = 'utm/v1/reports/transactions/export';

export const exportTransactions = (file, periodId, rowsIds, statusId, extraColumns) => dispatch => {
  if (statusId === '-') {
    statusId = null;
  }
  const isHeadersExport = true;
  exportFile({
    file,
    url: exportUrl,
    body: { periodId, rowsIds, statusId, isHeadersExport, extraColumns }
  })(dispatch);
};

export const exportAllTransactions = (file, periodId, rowsIds, statusId, extraColumns) => (dispatch, getState) => {
  if (statusId === '-') {
    statusId = null;
  }
  const isHeadersExport = true;
  const filtersParams = getUrlFilterParams(getState().invoiceFilters.tempFilters);

  exportFile({
    file,
    url: `${exportUrl}/all?periodId=${periodId}${statusId !== '-' ? `&lineStatusId=${statusId}` : ''
    }${filtersParams}`,
    body: { periodId, rowsIds, statusId, isHeadersExport, extraColumns }
  })(dispatch);
};

export const exportLines = (file, periodId, headerId, rowsIds, statusId) => dispatch => {
  if (statusId === '-') {
    statusId = null;
  }
  const isHeadersExport = false;
  exportFile({
    file,
    url: exportUrl,
    body: { periodId, rowsIds, headerId, statusId, isHeadersExport }
  })(dispatch);
};

export const changeInvoicesLinesStatus = (prevStatus, lineIdList, headerIdList, statusId, page, perPage) => dispatch => {
  axios.put(`${linesUrl}/status`, { headerIdList, statusId, lineIdList })
    .then( () => {
      dispatch(fetchInvoicesLines(headerIdList[0], prevStatus, page, perPage));
    })
    .catch(err => { throw err; });
};

export const changeInvoicesStatus = (prevStatus, headerIdList, statusId, page, perPage, periodId) => dispatch => {
  axios.put(`${url}/status`, { headerIdList, statusId })
    .then(() => {
      dispatch(fetchInvoices(periodId, prevStatus, page, perPage));
    })
    .catch(err => {
      throw err;
    });
};

export const changeAllInvoicesStatus = (periodId,prevStatus, statusId, page, perPage, value) => (dispatch, getState) => {
  const filtersParams = getUrlFilterParams(getState().invoiceFilters.tempFilters);
  axios.put(`${url}/all/status?periodId=${periodId}${statusId !== '-' ? `&lineStatusId=${statusId}` : ''
  }${filtersParams}`, {statusId: value}
  )
    .then(() => {
      dispatch(fetchInvoices(periodId, prevStatus, page, perPage));
    })
    .catch(error => { throw error; } );
};

export const fetchInvoices = (periodId, statusId, page, perPage) => (dispatch, getState) => {
  const filtersParams = getUrlFilterParams(getState().invoiceFilters.tempFilters);
  dispatch(fetchingInvoices());
  axios
    .get(
      `${url}?periodId=${periodId}&page=${page}&perPage=${perPage}${
        statusId !== '-' ? `&lineStatusId=${statusId}` : ''
      }${filtersParams}`
    )
    .then(invoicesResponse => {
      dispatch(resetInvoices());

      const { items, pageState } = invoicesResponse.data.data;
      if (items.length === 0 && page !== 0) {
        page = page - 1;
        dispatch(fetchInvoices(periodId, statusId, page, perPage));
      } else {
        dispatch(fetchInvoicesSuccess(items, pageState));
      }
    })
    .catch(err => {
      throw err;
    });
};

export const fetchInvoiceById = invoiceId => (dispatch) => {
  dispatch(fetchingInvoice());
  axios.get(`${url}/${invoiceId}`)
    .then(invoiceResponse => {
      dispatch(fetchInvoiceSuccess(invoiceResponse.data.data));
    })
    .catch(err => {
      throw err;
    });
};

export const fetchInvoicesLines = (invoiceId, statusId, page, perPage) => (dispatch, getState) => {
  const filtersParams = getUrlFilterParams(getState().invoiceLinesFilters.tempFilters);
  dispatch(fetchingInvoicesLines());
  axios.get(`${ url }/${ invoiceId }/invoice-lines?page=${ page }&perPage=${ perPage }${ statusId === '-' ? '' : '&lineStatusId=' +  statusId }${filtersParams}`)
    .then(responseInvoiceLines => {
      dispatch(resetInvoicesLines());

      const { items, pageState } = responseInvoiceLines.data.data;
      if(items.length === 0 && pageState.page !== 0) {
        pageState.page = pageState.page - 1;
        dispatch(fetchInvoicesLines(invoiceId,statusId,pageState.page,perPage));
      }
      else{
        dispatch(fetchingInvoicesLinesSuccess(items, pageState));
      }
    })
    .catch(err => { throw err; });
};

export const deleteInvoices = (invoices, periodId, statusId, page, perPage) => dispatch => {
  axios.post(`${url}/delete`, invoices )
    .then(() => {
      dispatch(deleteInvoicesSuccess());
      dispatch(fetchInvoices(periodId, statusId, page, perPage));
    })
    .catch(error => { throw error; } );
};

export const deleteAllInvoices = (periodId, statusId, page, perPage ) => (dispatch, getState) => {
  const filtersParams = getUrlFilterParams(getState().invoiceFilters.tempFilters);
  axios.post(`${url}/all/delete?periodId=${periodId}${statusId !== '-' ? `&lineStatusId=${statusId}` : ''
  }${filtersParams}`, []
  )
    .then(() => {
      dispatch(deleteInvoicesSuccess());
      dispatch(fetchInvoices(periodId, statusId, page, perPage));
    })
    .catch(error => { throw error; } );
};

export const deleteInvoiceLines = (lineIdList, headerId, statusId, page, perPage) => dispatch => {
  axios.post(`${linesUrl}/delete`, { headerId, lineIdList } )
    .then(() => {
      dispatch(deleteInvoiceLinesSuccess());
      dispatch(fetchInvoicesLines(headerId, statusId, page, perPage));
      dispatch(fetchInvoicesLinesUnfiltered(headerId, perPage));
      dispatch(fetchInvoiceById(headerId));
    })
    .catch(error => { throw error; } );
};

const fetchInvoicesLinesUnfiltered = (invoiceId, perPage) => dispatch => {
  axios.get(`${ url }/${ invoiceId }/invoice-lines?page=0&perPage=${ perPage }`)
    .then(responseInvoiceLines => {
      dispatch(fetchInvoiceLinesUnfilteredSuccess(responseInvoiceLines.data.data));
    })
    .catch(err => { throw err; });
};



// WEBPACK FOOTER //
// ./src/redux/invoices/InvoicesActions.js